import { useCurrentUser } from '../hooks/useCurrentUser';

export function Settings() {
  const { data: user, isLoading } = useCurrentUser();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-atg-navy">Settings</h1>
      <div className="bg-white rounded-lg shadow border border-slate-200 p-4">
        <div className="text-xs uppercase text-slate-500 mb-2">Current user</div>
        {isLoading && <div className="text-slate-400 text-sm">loading...</div>}
        {user && (
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div><dt className="text-slate-500">Email</dt><dd>{user.email ?? '-'}</dd></div>
            <div><dt className="text-slate-500">Display name</dt><dd>{user.displayName ?? '-'}</dd></div>
            <div><dt className="text-slate-500">Authenticated</dt><dd>{String(user.isAuthenticated)}</dd></div>
            <div><dt className="text-slate-500">Roles</dt><dd>{user.roles.join(', ') || '-'}</dd></div>
          </dl>
        )}
      </div>
      <div className="bg-white rounded-lg shadow border border-slate-200 p-4">
        <div className="text-xs uppercase text-slate-500 mb-2">Useful links</div>
        <ul className="text-sm space-y-1">
          <li><a className="text-atg-blue hover:underline" href="/swagger" target="_blank" rel="noreferrer">Swagger UI</a></li>
        </ul>
      </div>
    </div>
  );
}
